module.exports = __webpack_public_path__ + "static/media/FA.679cd81f.gif";